<script>
	/* core Svelte-Kit stores */
	import { page } from '$app/stores';
	import { browser } from '$app/environment';

	/* optional global default SEO store */
	import { seo as defaultSeo } from '$stores/seo';

	/* 🟢  PROPS  – using <SeoComp {...seo}/> passes each of these */
	export let title = '';
	export let description = '';
	export let keywords = '';
	export let img = '';

	/* ---------- helpers ---------- */
	function strip(html = '') {
		if (!html) return '';
		if (browser) {
			const doc = new DOMParser().parseFromString(html, 'text/html');
			return doc.body.textContent || '';
		}
		/* SSR fallback: quick tag remover */
		return html.replace(/<[^>]*>/g, '');
	}

	/* ---------- final values ---------- */
	$: meta = {
		title: title || $page.data?.seo?.title || defaultSeo?.title || 'HotDraw UK',

		description:
			description ||
			$page.data?.seo?.description ||
			defaultSeo?.description ||
			'Welcome to HotDraw UK, the best place for prize draws and competitions.',

		keywords:
			keywords ||
			$page.data?.seo?.keywords ||
			defaultSeo?.keywords ||
			'HotDraw UK, Prizes, Competitions, Prize Draw, Win Prizes',

		img:
			img ||
			$page.data?.seo?.img ||
			defaultSeo?.img ||
			'https://www.hotdraw.co.uk/hd-full-trans.png'
	};
</script>

<svelte:head>
	<!-- Primary -->
	<title>{meta.title}</title>
	<meta name="description" content={strip(meta.description)} />
	<meta name="keywords" content={meta.keywords} />

	<!-- Misc PWA helpers you were already using -->
	<meta name="mobile-web-app-capable" content="yes" />
	<meta name="apple-mobile-web-app-title" content="HotDraw UK" />

	<!-- Canonical URL -->
	<link rel="canonical" href={$page.url.href} />

	<!-- Open Graph -->
	<meta property="og:title" content={meta.title} />
	<meta property="og:type" content="website" />
	<meta property="og:url" content={$page.url.href} />
	<meta property="og:image" content={meta.img} />
	<meta property="og:description" content={strip(meta.description)} />
	<meta property="og:site_name" content="HotDraw UK" />

	<!-- Twitter -->
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:title" content={meta.title} />
	<meta name="twitter:description" content={strip(meta.description)} />
	<meta name="twitter:image" content={meta.img} />
</svelte:head>
